<template>
  <v-layout wrap>
     <v-card-title>
      <h2>Leave Tracking Calendar.</h2>
      <v-spacer></v-spacer>
       <v-divider inset></v-divider>
    </v-card-title>
    <v-flex
      xs12
      class="mb-3"
    >
      <v-sheet height="500">
        <v-calendar
          ref="calendar"
          v-model="today"
          color="primary"
          :now="today"
          :value="today"
        >
        <template v-slot:day="{ date }">
            <template v-for="event in eventsMap[date]">
              <v-menu
                :key="event.title"
                v-model="event.open"
                full-width
                offset-x
              >
                <template v-slot:activator="{ on }">
                  <div
                    v-if="!event.time"
                    v-ripple
                    class="my-event"
                    v-on="on"
                    v-html="event.title"
                  ></div>
                </template>
                <v-card
                  color="grey lighten-4"
                  min-width="350px"
                  flat
                >
                  <v-toolbar
                    color="primary"
                    dark
                  >
                    <v-btn icon>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-toolbar-title v-html="event.title"></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon>favorite</v-icon>
                    </v-btn>
                    <v-btn icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-title primary-title>
                    <span v-html="event.details"></span>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      flat
                      color="secondary"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>
          </template>
        </v-calendar>
      </v-sheet>
    </v-flex>

    <v-flex
      sm4
      xs12
      class="text-sm-left text-xs-center"
    >
      <v-btn @click="$refs.calendar.prev()">
        <v-icon
          dark
          left
        >
          keyboard_arrow_left
        </v-icon>
        Prev
      </v-btn>
    </v-flex>
    <v-flex
      sm4
      xs12
      class="text-xs-center"
    >
      <v-select
        v-model="type"
        :items="typeOptions"
        label="Type"
      ></v-select>
    </v-flex>
    <v-flex
      sm4
      xs12
      class="text-sm-right text-xs-center"
    >
      <v-btn @click="$refs.calendar.next()">
        Next
        <v-icon
          right
          dark
        >
          keyboard_arrow_right
        </v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
  export default {
    data: () => ({
     today: '2021-05-02',
     events: [],
     calendarLeave:[],
  }),

  //created meta data for calendar
  created() {
     this.today = new Date().toJSON().substr(0,10)

     commonService.getAllData('leave-management').then(res => {                                    
        res.data.forEach((c,i,f) => {
              
               let temp = {
                  title: c.staff_name,
                  details: `Name: ${c.staff_name}`+'<br>'+`Duration: From ${c.from_date}`+' to '+`${c.to_date}`+'<br>'+`Leave Address: ${	c.leave_contact_address	}`,
                  date: c.from_date,
                  date_end: c.to_date,
                  open:false
               };
               this.calendarLeave.push(temp)
        })
      
      });

     
      
  },
  computed: {

    // convert the list of events into a map of lists keyed by date
    eventsMap () {
      this.calendarLeave.forEach((item,index,full) => {
         let dateStart = new Date(item.date)
         let dateEnd = new Date(item.date_end)
         
         if(dateStart !== dateEnd) {
           for(let d = dateStart; d <= dateEnd; d.setDate(d.getDate() + 1)) {
                let date= d.toJSON().substr(0,10)
                let tempObject = {
                   title: item.title,
                   details: item.details,
                   date: date,
                   open:false
                }
                
                this.events.push(tempObject);
            }

      // console.log(this.events)

         }
      })

    const uniqueElements = (arr, fn) => arr.reduce((acc, v) => {
                if (!acc.some(x => fn(v, x))) { acc.push(v); }
                return acc;
    }, []);

    const events = this.events

    const unique = uniqueElements(events, (a,b) => a.date === b.date && a.title === b.title );
    this.events = unique
    const map = {}
    this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
      // console.log(map)
    return map
    }
  },
  methods: {
    open (event) {
      alert(event.title)
    }
  }
  }
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
</style>


// WEBPACK FOOTER //
// src/components/administration/leave_entry/eventCalendar.vue